import './global.css';
import './styles/CustomTheme.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter as Router} from "react-router-dom";
import SessionProvider from "./contexts/SessionContext";
import App from './App';
import store from './store';
import { Provider } from 'react-redux';
import { AuthProvider } from './contexts/AuthContext'; // Ensure this path is correct

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>  {/* Wrap outer most layer with redux provider */}
    <Router>
        <AuthProvider> {/* AuthProvider 2nd Layer */}
            <SessionProvider>
                    <App />
            </SessionProvider>
        </AuthProvider>
    </Router>
  </Provider>,
);
